import { createComponent } from '@helpers/admin';
import HeroSectionComponent from '@template/blocks/HeroSection/component';

export const Hero = createComponent({
  label: 'Hero',
  component: HeroSectionComponent,
  fields: {
    heading: {
      label: 'Heading',
      type: 'textarea',
    },
    subHeading: {
      label: 'Sub Heading',
      type: 'textarea',
    },
    image: {
      label: 'Image',
      type: 'image',
    },
    heroFooterImage: {
      label: 'Hero Footer Image',
      type: 'image',
    },
    buttons: {
      label: 'Buttons',
      type: 'array',
      arrayFields: {
        children: {
          label: 'Text',
          type: 'textarea',
        },
        link: {
          label: 'Link',
          type: 'text',
        },
        variant: {
          label: 'Variant',
          type: 'select',
          options: [
            { label: 'Flat', value: 'flat' },
            { label: 'Solid', value: 'solid' },
            { label: 'Outline', value: 'outline' },
          ],
        },
        target: {
          label: 'Open In New Tab',
          type: 'select',
          options: [
            { label: 'Yes', value: '_blank' },
            { label: 'No', value: '_self' },
          ],
        },
        color: {
          label: 'Color',
          type: 'select',
          options: [
            { label: 'Default', value: 'default' },
            { label: 'Primary', value: 'primary' },
            { label: 'Secondary', value: 'secondary' },
            { label: 'Success', value: 'success' },
          ],
        },
        title: {
          label: 'Title',
          type: 'textarea',
        },
      },
    },
    badges: {
      label: 'Badges',
      type: 'array',
      arrayFields: {
        link: {
          type: 'textarea',
          label: 'Link',
        },
        target: {
          label: 'Destination Type',
          type: 'radio',
          options: [
            {
              label: 'New Tab',
              value: '_blank',
            },
            {
              label: 'Same Tab',
              value: '_self',
            },
          ],
        },
        image: {
          label: 'Image',
          type: 'image',
        },
      },
    },
    reviews: {
      label: 'Show Reviews',
      type: 'boolean',
    },
    column: {
      label: 'Column Layout',
      type: 'boolean',
    },
    altStyling: {
      label: 'Alternative Styling',
      type: 'boolean',
    },
    greyBackground: {
      label: 'Grey Background',
      type: 'boolean',
    },
  },
});
